import { Field, FieldProps } from 'formik';
import React from 'react';
import { Grid } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { StyledErrorMessage } from '../StyledErrorMessage';
import { AccountData } from '../../api';
import { useAuth } from '../../session/InternalAuthProvider';
import { getDateFormat } from '../../common/getDateAndTimeFormat';
import { DATE_FORMAT } from '../../calendar/calendarWrapper/CalendarWrapper';
import { FormElementProps, getShouldMarkFieldAsUpdated } from './utils';

export const FormDatePicker = ({
  disabled,
  fieldName,
  label,
  onChange,
  isFieldUpdate,
  size,
  fullWidth,
  disablePast = true,
  minDate,
}: FormElementProps & {
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  disablePast?: boolean;
  minDate?: moment.Moment;
}) => {
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;
  const { longDateFormat } = getDateFormat(account);
  return (
    <Grid container justifyContent="flex-start">
      <Grid item {...(fullWidth ? { flex: 1 } : {})}>
        <Field name={fieldName}>
          {({ field, form }: FieldProps<string>) => {
            const shouldMarkFieldAsUpdated = getShouldMarkFieldAsUpdated(form, fieldName, field, isFieldUpdate);
            return (
              <DatePicker
                {...field}
                sx={{
                  '&& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                    borderColor: shouldMarkFieldAsUpdated ? 'primary.main' : undefined,
                    borderWidth: shouldMarkFieldAsUpdated ? 2 : undefined,
                  },
                  '&& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: shouldMarkFieldAsUpdated ? 'primary.main' : undefined,
                    borderWidth: shouldMarkFieldAsUpdated ? 2 : undefined,
                  },
                }}
                value={moment(field.value)}
                disabled={disabled}
                onChange={(newValue) => {
                  onChange?.(newValue);
                  void form.setFieldValue(fieldName, newValue!.format(DATE_FORMAT));
                }}
                disablePast={disablePast}
                minDate={minDate}
                format={longDateFormat}
                label={label}
                slotProps={{ textField: { size: size || 'medium', fullWidth } }}
              />
            );
          }}
        </Field>
        <StyledErrorMessage name={fieldName} />
      </Grid>
    </Grid>
  );
};
